/**
 * BusinessObjective CRUD
 */

import type { BusinessObjective } from '../../graphql/types';
import { createEntityCrudClient } from './crudFactory';

export interface ObjectiveMetricInput {
  name: string;
  baseline?: number;
  target: number;
  current?: number;
  unit?: string;
  measuredAt?: string;
}

export interface CreateBusinessObjectiveInput {
  name: string;
  description?: string;
  objectiveType: string;
  priority?: string;
  status?: string;
  startDate?: string;
  targetDate?: string;
  timeHorizon?: string;
  successCriteria?: string;
  kpiStatement?: string;
  metrics?: ObjectiveMetricInput[];
  ownerId: string;
  owningBusinessUnitId?: string;
  sponsorId?: string;
  tags?: string[];
  notes?: string;
}

export interface UpdateBusinessObjectiveInput {
  name?: string;
  description?: string;
  objectiveType?: string;
  priority?: string;
  status?: string;
  startDate?: string;
  targetDate?: string;
  timeHorizon?: string;
  successCriteria?: string;
  kpiStatement?: string;
  metrics?: ObjectiveMetricInput[];
  ownerId?: string;
  owningBusinessUnitId?: string;
  sponsorId?: string;
  tags?: string[];
  notes?: string;
}

const client = createEntityCrudClient<
  BusinessObjective,
  CreateBusinessObjectiveInput,
  UpdateBusinessObjectiveInput
>('/business-objectives');

export async function createBusinessObjective(
  input: CreateBusinessObjectiveInput
): Promise<BusinessObjective> {
  return client.create(input);
}

export async function updateBusinessObjective(
  businessObjectiveId: string,
  input: UpdateBusinessObjectiveInput
): Promise<BusinessObjective> {
  return client.update(businessObjectiveId, input);
}

export async function deleteBusinessObjective(
  businessObjectiveId: string,
  hardDelete: boolean = false
): Promise<void> {
  return client.remove(businessObjectiveId, hardDelete);
}
